import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import {
  CommittedAs,
  QARequestButtonState,
  WebinarRegistrationDto,
} from "integration/api/Deal/models";
import { InitialState } from "./models";
import { Tabs } from "application/constants/deal";
import { getDeal, getDealCommitment, registerWebinarQuestion, setInvestment } from "./actions";

const initialState: InitialState = {
  tab: Tabs.Overview,
  deal: null,
  isLoading: false,
  commitment: {
    amount: 0,
    commitment: 0,
    overcommitment: 0,
    investmentDoneAs: CommittedAs.INDIVIDUAL,
    legalEntityId: null,
  },
};

const initialWebinarRegistration: WebinarRegistrationDto = {
  answer: null,
  question: null,
  answerDate: null,
  noQuestion: false,
  replyLanguage: null,
};

const dealSlice = createSlice({
  name: "dealSlice",
  initialState,
  reducers: {
    setTab: (state, action: PayloadAction<Tabs>) => {
      state.tab = action.payload;
    },
  },
  extraReducers(builder) {
    // get deal
    builder.addCase(getDeal.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getDeal.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getDeal.fulfilled, (state, action) => {
      state.isLoading = false;
      state.deal = action.payload;
    });
    //get deal commitment
    builder.addCase(getDealCommitment.fulfilled, (state, action) => {
      state.commitment.amount = action.payload.amount;
      state.commitment.commitment = action.payload.commitment;
      state.commitment.overcommitment = action.payload.overcommitment;
    });
    //set investment
    builder.addCase(setInvestment.fulfilled, (state, action) => {
      state.commitment.amount = action.payload.amount;
      state.commitment.commitment = action.payload.commitment;
      state.commitment.overcommitment = action.payload.overcommitment;
    });

    // registerWebinarQuestion
    builder.addCase(registerWebinarQuestion.fulfilled, (state, { payload }) => {
      if (!state.deal) {
        return;
      }

      state.deal.requestQaButtonState = payload.noQuestion
        ? QARequestButtonState.REGISTRATION_CONFIRMED
        : QARequestButtonState.VIEW_QUESTION;

      if (!payload.noQuestion) {
        state.deal.webinarRegistration = {
          ...initialWebinarRegistration,
          question: payload.question ?? "",
        };
      }
    });
  },
});

export const { setTab } = dealSlice.actions;

export default dealSlice.reducer;
